/* ============
 * Public Profile Transformer
 * ============
 */

import Transformer from './transformer';

export default class PublicProfileTransformer extends Transformer {

  static fetch(publicProfile) {
    return {
      id: publicProfile.id,
      profileUrl: publicProfile.profile_url,
      header: publicProfile.header,
      subheader: publicProfile.subheader,
      defaultReminderTitle: publicProfile.default_reminder_title,
      defaultReminder: publicProfile.default_reminder,
      defaultCancelMessageTitle: publicProfile.default_cancel_message_title,
      defaultCancelMessage: publicProfile.default_cancel_message,
      appointmentConfirmationTemplate: publicProfile.appointment_confirmation_template,
      appointmentConfirmationTitle: publicProfile.appointment_confirmation_title,
      backgroundImage: publicProfile.background_image ?
                      { url: publicProfile.background_image } : undefined,
      stripeConnect: publicProfile.stripe_connect,
      bookingRequirePayment: publicProfile.booking_require_payment,
      bookingRequireAddress: publicProfile.booking_require_address,
      orgName: publicProfile.org_name,
      orgEmail: publicProfile.org_email,
      orgId: publicProfile.org_id,
      optinEmailSubject: publicProfile.optinEmailSubject,
      optinEmailBody: publicProfile.optinEmailBody,
    };
  }

  static send(publicProfile) {
    return {
      id: publicProfile.id,
      profile_url: publicProfile.profileUrl,
      header: publicProfile.header,
      subheader: publicProfile.subheader,
      default_reminder_title: publicProfile.defaultReminderTitle ? publicProfile.defaultReminderTitle : '',
      default_reminder: publicProfile.defaultReminder ? publicProfile.defaultReminder : '',
      default_cancel_message_title: publicProfile.defaultCancelMessageTitle ? publicProfile.defaultCancelMessageTitle : '',
      default_cancel_message: publicProfile.defaultCancelMessage ? publicProfile.defaultCancelMessage : '',
      appointment_confirmation_title: publicProfile.appointmentConfirmationTitle ? publicProfile.appointmentConfirmationTitle : '',
      appointment_confirmation_template: publicProfile.appointmentConfirmationTemplate ? publicProfile.appointmentConfirmationTemplate : '',
      background_image: publicProfile.backgroundImage.file ? publicProfile.backgroundImage.file : '',
      booking_require_payment: publicProfile.bookingRequirePayment,
      booking_require_address: publicProfile.bookingRequireAddress,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/publicProfile.js